module.exports = __webpack_public_path__ + "static/media/trophy_leaderboard_crest_Selected.a9e41fbb.svg";